import type { ConcreteDayDefinition } from "./Holiday_Days/index.js";

declare global {
	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface Window {
		isFrench: () => boolean;
	}
}

/** Checks if the holiday cards are present on the page and initializes the app. */
const containers = Array.from(
	document.querySelectorAll<HTMLDivElement>(".rt-holiday-cards"),
);
for (const container of containers) {
	let data: ConcreteDayDefinition[] = [];
	if (container.id === "plugin-holiday-cards") {
		const { warmestWishesDays } =
			await import("./Holiday_Days/Campaign_2022/index.js");
		data = warmestWishesDays;
	} else if (container.id === "tba-holiday-cards") {
		const { happyHolidaysDays } =
			await import("./Holiday_Days/Campaign_2023/index.js");
		data = happyHolidaysDays;
	} else if (container.id === "holiday-cards-2024") {
		const { happyHolidays2024Days } =
			await import("./Holiday_Days/Campaign_2024/index.js");
		data = happyHolidays2024Days;
	} else if (container.id === "holiday-cards-2025") {
		const { happyHolidays2025Days } =
			await import("./Holiday_Days/Campaign_2025/index.js");
		data = happyHolidays2025Days;
	}
	if (!data.length) {
		continue;
	}
	const { createApp } = await import("./HolidayCards.js");

	createApp(container, data);
}

const happyHolidaysAnimation = document.querySelector<HTMLDivElement>(
	"#happy-holidays-animation",
);
if (happyHolidaysAnimation) {
	const { init: initAnimation } = await import("./HappyHolidaysAnimation.js");
	initAnimation(happyHolidaysAnimation);
}

const warmestWishesAnimation = document.querySelector<HTMLDivElement>(
	"#warmest-wishes-animation",
);
if (warmestWishesAnimation) {
	const { init: initAnimation } = await import("./WarmestWishesAnimation.js");
	initAnimation(warmestWishesAnimation);
}

const happyHolidays2024Animation = document.querySelector<HTMLDivElement>(
	"#holiday-animation-2024",
);
if (happyHolidays2024Animation) {
	const { init: initAnimation } =
		await import("./2024-animation/2024Animation.js");
	initAnimation(happyHolidays2024Animation);
}

const happyHolidays2025Animation = document.querySelector<HTMLDivElement>(
	"#holiday-animation-2025",
);
if (happyHolidays2025Animation) {
	const { init: initAnimation } =
		await import("./2025-animation/2025Animation.js");
	initAnimation(happyHolidays2025Animation);
}
